import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import createLink from "../../../libs/createLink";

import {fetchUserFriendsSidebar, resetUserFriendsSidebar} from "../../../creators/user.friends.sidebar";

import AvatarFriend from "./components/AvatarFriend";
import {Button} from "../Button";
import _ from "lodash";

class FriendsListSidebar extends React.Component {
    componentDidMount() {
        if(_.get(this.props, "user._id")){
            this.props.fetchUserFriendsSidebar(this.props.user._id, {limit: 9, page: 1})
        }

    }

    componentWillUnmount() {
        this.props.resetUserFriendsSidebar();
    }

    render() {
        return this.props.userFriendsSidebarTotal > 0 && (
            <div className="friends-wrapper">
                {this.props.userFriendsSidebarInitialized && this.props.userFriendsSidebarTotal >= 0 && (
                    <Fragment>
                        {this.props.displayTitle && (
                            <div className="topline">
                                <Link className={"head-title display-5"}
                                      to={this.props.isMe ? createLink('userMeFriends', this.props.user) : createLink('userFriends', this.props.user)} rel={"nofollow"}>
                                    {`${this.props.isMe ? 'Mes' : 'Ses'} ${this.props.userFriendsSidebarTotal} ami(e)${this.props.userFriendsSidebarTotal > 1 ? "s" : ""}`}
                                </Link>
                            </div>
                        )}
                        <div className={"list"}>
                            {this.props.userFriendsSidebar.map((item) => (
                                <AvatarFriend {...item}
                                              key={item._id}
                                              userFriendsInitialized={this.props.userFriendsSidebarInitialized}/>

                            ))}
                        </div>
                        <Button btnStyle={"primary-reverse"}
                                size={"medium"}
                                to={this.props.isMe ? createLink('userMeFriends', this.props.user): createLink('userFriends', this.props.user)}
                                content={"Voir plus d'amis"} rel={"nofollow"}/>
                    </Fragment>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFriendsSidebar: state.userFriendsSidebar.data,
        userFriendsSidebarInitialized: state.userFriendsSidebar,

        userFriendsSidebarTotal: state.userFriendsSidebar.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFriendsSidebar,
    resetUserFriendsSidebar,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(FriendsListSidebar);
